import React from 'react';
import Swal from 'sweetalert2';
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams, Link } from 'react-router-dom';
import {
    faSearch,
    faUserPlus,
    faList,
    faPlus,
    faUser,
    faFolderPlus,
    faInfo,
    faCheckCircle,
    faClock,
    faFileAlt,
    faEye,
    faEdit,
    faPrint,
    faUsers,
    faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import CrearFormulario from '../Master/CrearFormulario';

class Crear extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            // Estado de búsqueda
            cedula: '',
            pacienteEncontrado: null,
            ordenesActivas: [],
            cargando: false,
            cargandoModelos: true,
            errorModelos: null,

            // Modelos para FormularioCrear
            modeloPaciente: { tabla: [], pesta: [], titulo: '' },
            modeloArchivo: { tabla: [], pesta: [], titulo: '' },
            modeloCondiciones: { tabla: [], pesta: [], titulo: '' },
            modeloParientes: { tabla: [], pesta: [], titulo: '' },

            // Para crear archivo
            pacienteId: null,
            ordenSeleccionada: null,
            mostrarFormularioArchivo: false,

            // Para condiciones de vivienda
            condicionesId: null,
            existeCondiciones: false,
            mostrarFormularioCondiciones: false,
            activeTab: 'general',

            // Para acudientes (parientes)
            parientes: [],
            cargandoParientes: false,
            mostrarFormularioParientes: false,
            parienteSeleccionadoId: null
        };
    }

    /**
     * Guardar datos en localStorage para ver el archivo
     */
    verOrden = (id, tabla) => {
        window.localStorage.setItem("Archivo", id);
        window.localStorage.setItem("TablaId", tabla);
    }

    componentDidMount() {
        this._isMounted = true;
        console.log('Componente montado, cargando modelos...');
        this.cargarModelos();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    /**
     * Cargar modelos de paciente y archivo desde la API
     */
    cargarModelos = async () => {
        const u = localStorage.getItem("idusuario");
        console.log('ID Usuario:', u);

        try {
            console.log('Iniciando carga de modelos...');

            // Cargar modelo Paciente (168)
            const resPaciente = await authAxios.get(`master/vermodelo/168/${u}`);
            console.log('Respuesta Paciente:', resPaciente.data);

            // Cargar modelo Archivo (200)
            const resArchivo = await authAxios.get(`master/vermodelo/200/${u}`);
            console.log('Respuesta Archivo:', resArchivo.data);

            // Cargar modelo Condiciones (195)
            const resCondiciones = await authAxios.get(`master/vermodelo/195/${u}`);
            console.log('Respuesta Condiciones:', resCondiciones.data);

            // Cargar modelo Parientes (192)
            const resParientes = await authAxios.get(`master/vermodelo/192/${u}`);
            console.log('Respuesta Parientes:', resParientes.data);

            if (this._isMounted) {
                const modeloPacienteData = {
                    tabla: resPaciente.data.modelo || [],
                    pesta: resPaciente.data.nav || [],
                    titulo: resPaciente.data.titulo || 'Paciente'
                };

                const modeloArchivoData = {
                    tabla: resArchivo.data.modelo || [],
                    pesta: resArchivo.data.nav || [],
                    titulo: resArchivo.data.titulo || 'Archivo'
                };

                const modeloCondicionesData = {
                    tabla: resCondiciones.data.modelo || [],
                    pesta: resCondiciones.data.nav || [],
                    titulo: resCondiciones.data.titulo || 'Condiciones de Vivienda'
                };

                const modeloParientesData = {
                    tabla: resParientes.data.modelo || [],
                    pesta: resParientes.data.nav || [],
                    titulo: resParientes.data.titulo || 'Acudientes'
                };

                console.log('Modelo Paciente procesado:', modeloPacienteData);
                console.log('Modelo Archivo procesado:', modeloArchivoData);
                console.log('Modelo Condiciones procesado:', modeloCondicionesData);
                console.log('Modelo Parientes procesado:', modeloParientesData);

                this.setState({
                    modeloPaciente: modeloPacienteData,
                    modeloArchivo: modeloArchivoData,
                    modeloCondiciones: modeloCondicionesData,
                    modeloParientes: modeloParientesData,
                    cargandoModelos: false,
                    errorModelos: null
                });
            }
        } catch (error) {
            console.error("Error cargando modelos:", error);
            if (this._isMounted) {
                const errorMsg = error.response?.data?.message || error.message || 'Error desconocido';
                this.setState({
                    cargandoModelos: false,
                    errorModelos: errorMsg
                });
                Swal.fire('Error', 'No se pudieron cargar los modelos de formulario: ' + errorMsg, 'error');
            }
        }
    }

    /**
     * Manejar cambios en los inputs
     */
    cambioValor = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    /**
     * Buscar paciente por cédula
     */
    buscarPaciente = async (e) => {
        if (e) e.preventDefault();
        const { cedula } = this.state;

        if (!cedula || cedula.trim() === '') {
            Swal.fire('Atención', 'Ingrese una cédula para buscar', 'warning');
            return;
        }

        this.setState({ cargando: true });

        try {
            console.log('Buscando paciente con cédula:', cedula);
            const response = await authAxios.post('crear_orden/buscar_paciente', { cedula });
            console.log('Respuesta búsqueda paciente:', response.data);

            if (this._isMounted) {
                if (response.data.Status) {
                    // Paciente encontrado
                    this.setState({
                        pacienteEncontrado: response.data.paciente,
                        ordenesActivas: response.data.ordenes_activas || [],
                        pacienteId: response.data.paciente.id,
                        cargando: false,
                        mostrarFormularioArchivo: false,
                        ordenSeleccionada: null,
                        activeTab: 'general'
                    }, () => {
                        this.consultarCondiciones(response.data.paciente.id);
                        this.consultarParientes(response.data.paciente.id);
                    });

                    // Mostrar notificación de éxito
                    Swal.fire({
                        icon: 'success',
                        title: 'Paciente Encontrado',
                        text: `${response.data.paciente.nombre} ${response.data.paciente.apellido}`,
                        timer: 2000,
                        showConfirmButton: false
                    });
                } else {
                    // Paciente no encontrado
                    this.setState({
                        pacienteEncontrado: null,
                        ordenesActivas: [],
                        cargando: false,
                        pacienteId: null,
                        condicionesId: null,
                        existeCondiciones: false
                    });

                    // Preguntar si desea crear paciente
                    Swal.fire({
                        title: 'Paciente no encontrado',
                        text: '¿Desea registrar al paciente?',
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Sí, registrar',
                        cancelButtonText: 'No',
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#6c757d'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.abrirModalPaciente();
                        }
                    });
                }
            }
        } catch (error) {
            console.error('Error buscando paciente:', error);
            if (this._isMounted) {
                this.setState({ cargando: false });
                Swal.fire('Error', 'Error al consultar el paciente', 'error');
            }
        }
    }

    /**
     * Abrir modal para crear paciente
     */
    abrirModalPaciente = () => {
        console.log('Abriendo modal de paciente...');
        const modalElement = document.getElementById('modal_paciente');
        if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');

            // Agregar backdrop
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = 1055; // Asegurar que esté debajo del modal (1060)
            document.body.appendChild(backdrop);
        } else {
            console.error('Modal element no encontrado');
        }
    }

    /**
     * Cerrar modal de paciente
     */
    cerrarModalPaciente = () => {
        console.log('Cerrando modal de paciente...');
        const modalElement = document.getElementById('modal_paciente');
        if (modalElement) {
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');

            // Remover backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
        }
    }

    /**
     * Callback cuando se registra un paciente
     */
    onPacienteRegistrado = (tabla, id, data) => {
        console.log('Paciente registrado con ID:', id, 'Datos:', data);
        this.cerrarModalPaciente();

        // Si los datos contienen la cédula, actualizamos el state y buscamos
        if (data && data.cedula) {
            this.setState({ cedula: data.cedula }, () => {
                this.buscarPaciente();
            });
        } else if (this.state.cedula) {
            // Si no viene en data pero tenemos algo en el state, buscamos
            this.buscarPaciente();
        } else {
            console.warn('No se pudo encontrar la cédula para buscar automáticamente');
        }
    }

    /**
     * Consultar si el paciente tiene condiciones de vivienda registradas (menú 195)
     */
    consultarCondiciones = async (pacienteId) => {
        const u = localStorage.getItem("idusuario");
        try {
            console.log('Consultando condiciones de vivienda para paciente:', pacienteId);
            const response = await authAxios.post(`master/index/195/${u}`, { BUS_cedula: pacienteId });
            const records = response.data.data?.data || [];
            if (this._isMounted) {
                if (records.length > 0) {
                    this.setState({
                        condicionesId: records[0].id,
                        existeCondiciones: true
                    });
                } else {
                    this.setState({
                        condicionesId: null,
                        existeCondiciones: false
                    });
                }
            }
        } catch (error) {
            console.error("Error consultando condiciones de vivienda:", error);
        }
    }

    /**
     * Consultar acudientes (parientes) del paciente (menú 192)
     */
    consultarParientes = async (pacienteId) => {
        const u = localStorage.getItem("idusuario");
        this.setState({ cargandoParientes: true });
        try {
            console.log('Consultando acudientes para paciente:', pacienteId);
            const response = await authAxios.post(`master/index/192/${u}`, { BUS_paciente: pacienteId });
            const records = response.data.data?.data || [];
            if (this._isMounted) {
                this.setState({
                    parientes: records,
                    cargandoParientes: false
                });
            }
        } catch (error) {
            console.error("Error consultando acudientes:", error);
            if (this._isMounted) {
                this.setState({
                    parientes: [],
                    cargandoParientes: false
                });
            }
        }
    }

    /**
     * Abrir modal para acudiente (crear o editar)
     */
    activarFormParientes = (parienteId = null) => {
        console.log('Abriendo formulario de acudiente con ID:', parienteId);
        this.setState({
            mostrarFormularioParientes: true,
            parienteSeleccionadoId: parienteId
        });

        const modalElement = document.getElementById('modal_parientes');
        if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');

            // Agregar backdrop
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = 1055;
            document.body.appendChild(backdrop);
        } else {
            console.error('Modal acudientes no encontrado');
        }
    }

    /**
     * Cerrar modal de acudientes
     */
    cerrarModalParientes = () => {
        console.log('Cerrando modal de acudientes...');
        this.setState({
            mostrarFormularioParientes: false,
            parienteSeleccionadoId: null
        });

        const modalElement = document.getElementById('modal_parientes');
        if (modalElement) {
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');

            // Remover backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
        }
    }

    /**
     * Callback cuando se guarda un acudiente
     */
    onParientesRegistrado = (tabla, id) => {
        console.log('Acudiente guardado con ID:', id);
        this.cerrarModalParientes();

        Swal.fire({
            title: '¡Acudiente Guardado!',
            text: 'El acudiente ha sido registrado/actualizado correctamente.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
        });

        if (this.state.pacienteId) {
            this.consultarParientes(this.state.pacienteId);
        }
    }

    /**
     * Eliminar acudiente
     */
    eliminarPariente = (parienteId) => {
        const u = localStorage.getItem("idusuario");
        Swal.fire({
            title: '¿Está seguro de eliminar este acudiente?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                authAxios.get(`master/borrar/192/${parienteId}/${u}`)
                    .then((response) => {
                        Swal.fire('¡Eliminado!', response.data.msj || 'El acudiente ha sido eliminado.', 'success');
                        if (this.state.pacienteId) {
                            this.consultarParientes(this.state.pacienteId);
                        }
                    })
                    .catch((error) => {
                        console.error("Error al eliminar acudiente:", error);
                        Swal.fire('Error', 'No se pudo eliminar el acudiente.', 'error');
                    });
            }
        });
    }

    /**
     * Abrir formulario/modal para condiciones de vivienda
     */
    activarFormCondiciones = () => {
        console.log('Abriendo formulario de condiciones de vivienda...');
        this.setState({
            mostrarFormularioCondiciones: true
        });

        const modalElement = document.getElementById('modal_condiciones');
        if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');

            // Agregar backdrop
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = 1055; // Asegurar que esté debajo del modal (1060)
            document.body.appendChild(backdrop);
        } else {
            console.error('Modal condiciones no encontrado');
        }
    }

    /**
     * Cerrar modal de condiciones de vivienda
     */
    cerrarModalCondiciones = () => {
        console.log('Cerrando modal de condiciones de vivienda...');
        const modalElement = document.getElementById('modal_condiciones');
        if (modalElement) {
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');

            // Remover backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
        }

        this.setState({
            mostrarFormularioCondiciones: false
        });
    }

    /**
     * Callback cuando se registran/guardan las condiciones
     */
    onCondicionesRegistrado = (tabla, id) => {
        console.log('Condiciones de vivienda guardadas con ID:', id);
        this.cerrarModalCondiciones();

        Swal.fire({
            title: '¡Condiciones Guardadas!',
            text: 'Las condiciones de vivienda han sido guardadas correctamente.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
        });

        if (this.state.pacienteId) {
            this.consultarCondiciones(this.state.pacienteId);
        }
    }

    /**
     * Imprimir las condiciones de vivienda
     */
    imprimirCondiciones = async () => {
        const { condicionesId } = this.state;
        if (!condicionesId) return;

        Swal.fire({
            title: 'Generando Documento',
            text: 'Por favor espere...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const response = await authAxios.get(`/documento_pdf/${condicionesId}/195`);

            if (response.data.status) {
                const pdfWindow = window.open('', '_blank');
                if (pdfWindow) {
                    pdfWindow.document.write(`
                        <html>
                            <head>
                                <title>Condiciones de Vivienda</title>
                                <style>
                                    body { margin: 0; padding: 0; overflow: hidden; }
                                    iframe { width: 100%; height: 100vh; border: none; }
                                </style>
                            </head>
                            <body>
                                <iframe 
                                    src="data:application/pdf;base64,${response.data.data}" 
                                    title="Condiciones de Vivienda"
                                ></iframe>
                            </body>
                        </html>
                    `);
                }
                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'PDF generado',
                    text: 'El documento se abrirá en una nueva ventana',
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                throw new Error('Error en respuesta base64');
            }
        } catch (error) {
            console.log('Intentando método alternativo de descarga...');
            try {
                const directResponse = await authAxios.get(`/documento_pdf/${condicionesId}/195`, {
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([directResponse.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `condiciones_${condicionesId}_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
                Swal.close();
                Swal.fire({
                    icon: 'success',
                    title: 'Descarga iniciada',
                    text: 'El documento se está descargando',
                    timer: 2000,
                    showConfirmButton: false
                });
            } catch (fallbackError) {
                console.error('Error en ambos métodos:', fallbackError);
                Swal.close();
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo generar el documento',
                    confirmButtonText: 'Entendido'
                });
            }
        }
    }

    /**
     * Abrir formulario para crear archivo
     */
    activarFormArchivo = (ordenSeleccionada = null) => {
        console.log('Abriendo formulario de archivo...');
        this.setState({
            mostrarFormularioArchivo: true,
            ordenSeleccionada: ordenSeleccionada
        });

        const modalElement = document.getElementById('modal_archivo');
        if (modalElement) {
            modalElement.classList.add('show');
            modalElement.style.display = 'block';
            document.body.classList.add('modal-open');

            // Agregar backdrop
            const backdrop = document.createElement('div');
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = 1055; // Asegurar que esté debajo del modal (1060)
            document.body.appendChild(backdrop);
        } else {
            console.error('Modal archivo no encontrado');
        }
    }

    /**
     * Cerrar modal de archivo
     */
    cerrarModalArchivo = () => {
        console.log('Cerrando modal de archivo...');
        const modalElement = document.getElementById('modal_archivo');
        if (modalElement) {
            modalElement.classList.remove('show');
            modalElement.style.display = 'none';
            document.body.classList.remove('modal-open');

            // Remover backdrop
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach(backdrop => backdrop.remove());
        }

        this.setState({
            mostrarFormularioArchivo: false,
            ordenSeleccionada: null
        });
    }

    /**
     * Callback cuando se registra un archivo
     */
    onArchivoRegistrado = (tabla, id) => {
        console.log('Archivo registrado con ID:', id);
        this.cerrarModalArchivo();

        // Guardar en localStorage
        localStorage.setItem("Archivo", "200");
        localStorage.setItem("TablaId", id);

        Swal.fire({
            title: '¡Archivo Creado!',
            text: 'Redirigiendo al módulo de órdenes...',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
        });

        // Redirigir después de 2 segundos
        setTimeout(() => {
            window.location.href = "/pages/orden/Dubai";
        }, 2000);
    }

    /**
     * Calcular edad del paciente
     */
    calcularEdad = (fechaNacimiento) => {
        const hoy = new Date();
        const nacimiento = new Date(fechaNacimiento);
        let edad = hoy.getFullYear() - nacimiento.getFullYear();
        const mes = hoy.getMonth() - nacimiento.getMonth();

        if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
            edad--;
        }

        return edad;
    }

    /**
     * Formatear fecha
     */
    formatearFecha = (fecha) => {
        if (!fecha) return 'N/A';
        const date = new Date(fecha);
        return date.toLocaleDateString('es-CO');
    }

    render() {
        const {
            cedula,
            pacienteEncontrado,
            ordenesActivas,
            cargando,
            cargandoModelos,
            errorModelos,
            modeloPaciente,
            modeloArchivo,
            modeloCondiciones,
            pacienteId,
            condicionesId,
            existeCondiciones,
            mostrarFormularioCondiciones,
            activeTab,
            modeloParientes,
            parientes,
            parienteSeleccionadoId
        } = this.state;

        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />

                        {/* ==================== BUSCADOR DE PACIENTES ==================== */}
                        <div className="card shadow-sm border-0">
                            <div className="card-header bg-primary text-white d-flex align-items-center">
                                <FontAwesomeIcon icon={faSearch} className="me-2" />
                                <h5 className="mb-0">Búsqueda de Paciente</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.buscarPaciente} className="row g-3 align-items-end">
                                    <div className="col-md-6">
                                        <label className="form-label fw-bold">
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            Ingrese la Cédula del Paciente
                                        </label>
                                        <div className="input-group">
                                            <input
                                                className="form-control form-control-lg"
                                                type="text"
                                                name="cedula"
                                                value={cedula}
                                                placeholder="Ej: 12345678"
                                                onChange={this.cambioValor}
                                                disabled={cargando}
                                                autoFocus
                                            />
                                            <button
                                                type="submit"
                                                className="btn btn-success btn-lg"
                                                disabled={cargando || !cedula.trim()}
                                            >
                                                {cargando ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                                        Buscando...
                                                    </>
                                                ) : (
                                                    <>
                                                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                                                        Buscar
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="alert alert-info mb-0" role="alert">
                                            <FontAwesomeIcon icon={faInfo} className="me-2" />
                                            Ingrese el número de cédula del paciente para continuar
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* ==================== INFORMACIÓN DEL PACIENTE ==================== */}
                        {/* ==================== INFORMACIÓN DEL PACIENTE ==================== */}
                        {pacienteEncontrado && (
                            <div className="animate__animated animate__fadeIn">
                                <ul className="nav nav-tabs mt-4 border-bottom-0" role="tablist" style={{ gap: '5px' }}>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-bold px-4 py-2 border-0 rounded-top ${activeTab === 'general' ? 'active bg-white text-primary border-top border-start border-end' : 'bg-light text-muted'}`}
                                            onClick={() => this.setState({ activeTab: 'general' })}
                                            type="button"
                                            role="tab"
                                            aria-selected={activeTab === 'general'}
                                            style={{ transition: 'all 0.2s' }}
                                        >
                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                            Información General
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-bold px-4 py-2 border-0 rounded-top ${activeTab === 'condiciones' ? 'active bg-white text-primary border-top border-start border-end' : 'bg-light text-muted'}`}
                                            onClick={() => this.setState({ activeTab: 'condiciones' })}
                                            type="button"
                                            role="tab"
                                            aria-selected={activeTab === 'condiciones'}
                                            style={{ transition: 'all 0.2s' }}
                                        >
                                            <FontAwesomeIcon icon={faInfo} className="me-2" />
                                            Condiciones de Vivienda
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link fw-bold px-4 py-2 border-0 rounded-top ${activeTab === 'acudientes' ? 'active bg-white text-primary border-top border-start border-end' : 'bg-light text-muted'}`}
                                            onClick={() => this.setState({ activeTab: 'acudientes' })}
                                            type="button"
                                            role="tab"
                                            aria-selected={activeTab === 'acudientes'}
                                            style={{ transition: 'all 0.2s' }}
                                        >
                                            <FontAwesomeIcon icon={faUsers} className="me-2" />
                                            Acudientes
                                        </button>
                                    </li>
                                </ul>

                                <div className="tab-content bg-white p-3 border rounded-bottom shadow-sm">
                                    {activeTab === 'general' && (
                                        <div className="animate__animated animate__fadeIn">
                                            {/* Card con info del paciente */}
                                            <div className="card shadow-sm border-0 border-left-primary">
                                                <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <FontAwesomeIcon icon={faUser} className="me-2" />
                                                        <b>Información del Paciente</b>
                                                    </div>
                                                    <button
                                                        className="btn btn-success btn-sm fw-bold"
                                                        onClick={() => this.activarFormArchivo()}
                                                        title="Crear nuevo archivo para este paciente"
                                                    >
                                                        <FontAwesomeIcon icon={faFolderPlus} className="me-2" />
                                                        Crear Archivo
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row g-4">
                                                        <div className="col-md-3">
                                                            <div className="d-flex align-items-center">
                                                                <div className="avatar-lg bg-primary rounded-circle d-flex align-items-center justify-content-center text-white me-3" style={{ width: '60px', height: '60px', minWidth: '60px' }}>
                                                                    <FontAwesomeIcon icon={faUser} size="lg" />
                                                                </div>
                                                                <div>
                                                                    <small className="text-muted d-block text-uppercase fw-bold">Nombre Completo</small>
                                                                    <span className="fw-bold">{pacienteEncontrado.nombre} {pacienteEncontrado.apellido}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <small className="text-muted d-block text-uppercase fw-bold">Cédula</small>
                                                            <span className="badge bg-secondary p-2">{pacienteEncontrado.cedula}</span>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <small className="text-muted d-block text-uppercase fw-bold">Edad</small>
                                                            <span className="fw-bold">{pacienteEncontrado.fecha_nacimiento ? this.calcularEdad(pacienteEncontrado.fecha_nacimiento) + ' años' : 'N/A'}</span>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <small className="text-muted d-block text-uppercase fw-bold">EPS</small>
                                                            <span className="badge bg-warning text-dark p-2">{pacienteEncontrado.eps || 'No definida'}</span>
                                                        </div>
                                                    </div>
                                                    <hr className="my-3" />
                                                    <div className="row g-3">
                                                        <div className="col-md-4">
                                                            <small className="text-muted d-block text-uppercase fw-bold">Teléfono</small>
                                                            <span>{pacienteEncontrado.telefono || 'N/A'}</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <small className="text-muted d-block text-uppercase fw-bold">Celular</small>
                                                            <span>{pacienteEncontrado.celular || 'N/A'}</span>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <small className="text-muted d-block text-uppercase fw-bold">Email</small>
                                                            <span>{pacienteEncontrado.email || 'N/A'}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Card con órdenes activas */}
                                            <div className="card mt-4 shadow-sm border-0">
                                                <div className="card-header bg-dark text-white d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faList} className="me-2" />
                                                    <h6 className="mb-0">
                                                        Órdenes Activas
                                                        {ordenesActivas.length > 0 && (
                                                            <span className="badge bg-danger ms-2">{ordenesActivas.length}</span>
                                                        )}
                                                    </h6>
                                                </div>
                                                <div className="card-body p-0">
                                                    {ordenesActivas.length > 0 ? (
                                                        <div className="table-responsive">
                                                            <table className="table table-hover mb-0 align-middle">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th className="px-3">
                                                                            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                                                            Archivo
                                                                        </th>
                                                                        <th className="px-3">
                                                                            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                                                            ID Orden
                                                                        </th>
                                                                        <th className="px-3">
                                                                            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                                                            Completado
                                                                        </th>
                                                                        <th className="px-3">
                                                                            <FontAwesomeIcon icon={faFileAlt} className="me-2" />
                                                                            Fecha Ingreso
                                                                        </th>
                                                                        <th>
                                                                            <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                                                                            Atención
                                                                        </th>
                                                                        <th className="text-center">
                                                                            <FontAwesomeIcon icon={faClock} className="me-2" />
                                                                            Cantidad
                                                                        </th>
                                                                        <th>
                                                                            <FontAwesomeIcon icon={faUser} className="me-2" />
                                                                            Asignado
                                                                        </th>

                                                                        <th className="text-center">Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {ordenesActivas.map((orden) => (
                                                                        <tr key={orden.id} className="border-bottom">
                                                                            <td className="px-3">
                                                                                <span className="badge bg-primary">{orden.archivo}</span>
                                                                            </td>
                                                                            <td className="px-3">
                                                                                <span className="badge bg-primary">{orden.id || 'N/A'}</span>
                                                                            </td>
                                                                            <td className="px-3">
                                                                                <span className="badge bg-primary">{orden.porcentaje || 'N/A'}</span>
                                                                            </td>
                                                                            <td className="px-3">
                                                                                <span className="badge bg-primary">{orden.fecha_inicial || 'N/A'}</span>
                                                                            </td>
                                                                            <td className="px-3">
                                                                                <span className="badge bg-primary">{orden.atencion_nombre || 'N/A'}</span>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <span className="badge rounded-pill bg-info">{orden.cantidad || 1}</span>
                                                                            </td>
                                                                            <td>
                                                                                <div className="d-flex align-items-center">
                                                                                    <div
                                                                                        className="avatar-sm me-2 bg-light rounded-circle d-flex align-items-center justify-content-center"
                                                                                        style={{ width: '32px', height: '32px', minWidth: '32px' }}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faUser} size="sm" className="text-muted" />
                                                                                    </div>
                                                                                    <small>{orden.asignado_nombre || 'Sin asignar'}</small>
                                                                                </div>
                                                                            </td>

                                                                            <td className="text-center">
                                                                                {orden.archivo ? (
                                                                                    <Link
                                                                                        className="btn btn-success btn-sm rounded-pill"
                                                                                        to={"../pages/orden/Dubai"}
                                                                                        onClick={() => this.verOrden(200, orden.archivo)}
                                                                                        title="Ver archivo de esta orden"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faEye} className="me-1" />
                                                                                        Ir al Archivo
                                                                                    </Link>
                                                                                ) : (
                                                                                    <button
                                                                                        className="btn btn-outline-success btn-sm rounded-pill"
                                                                                        onClick={() => this.activarFormArchivo(orden)}
                                                                                        title="Crear archivo para esta orden"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                                                                                        Crear Archivo
                                                                                    </button>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="p-4 text-center">
                                                            <FontAwesomeIcon icon={faInfo} size="lg" className="text-muted mb-3" style={{ fontSize: '3rem' }} />
                                                            <p className="text-muted mt-3">
                                                                No hay órdenes activas para este paciente.
                                                            </p>
                                                            <button
                                                                className="btn btn-primary btn-sm mt-2"
                                                                onClick={() => this.activarFormArchivo()}
                                                            >
                                                                <FontAwesomeIcon icon={faFolderPlus} className="me-2" />
                                                                Crear Archivo Nuevo
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'condiciones' && (
                                        <div className="animate__animated animate__fadeIn">
                                            <div className="card shadow-sm border-0">
                                                <div className="card-header bg-success text-white d-flex align-items-center">
                                                    <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                    <h5 className="mb-0">Condiciones de Vivienda</h5>
                                                </div>
                                                <div className="card-body text-center py-5">
                                                    {!existeCondiciones ? (
                                                        <div>
                                                            <p className="text-muted fs-5">
                                                                No se han registrado las condiciones de vivienda de este paciente.
                                                            </p>
                                                            <button
                                                                className="btn btn-primary btn-lg mt-3"
                                                                onClick={this.activarFormCondiciones}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                                                Ver condiciones de vivienda
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <p className="text-success fs-5 fw-bold mb-4">
                                                                Las condiciones de vivienda están registradas.
                                                            </p>
                                                            <div className="d-flex justify-content-center gap-3">
                                                                <button
                                                                    className="btn btn-warning btn-lg px-4"
                                                                    onClick={this.activarFormCondiciones}
                                                                >
                                                                    <FontAwesomeIcon icon={faEdit} className="me-2" />
                                                                    Editar condiciones
                                                                </button>
                                                                <button
                                                                    className="btn btn-info btn-lg text-white px-4"
                                                                    onClick={this.imprimirCondiciones}
                                                                >
                                                                    <FontAwesomeIcon icon={faPrint} className="me-2" />
                                                                    Imprimir
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {activeTab === 'acudientes' && (
                                        <div className="animate__animated animate__fadeIn">
                                            <div className="card shadow-sm border-0">
                                                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                                    <div className="d-flex align-items-center">
                                                        <FontAwesomeIcon icon={faUsers} className="me-2" />
                                                        <h5 className="mb-0">Acudientes del Paciente</h5>
                                                    </div>
                                                    <button
                                                        className="btn btn-light btn-sm fw-bold text-primary"
                                                        onClick={() => this.activarFormParientes()}
                                                    >
                                                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                                                        Agregar Acudiente
                                                    </button>
                                                </div>
                                                <div className="card-body">
                                                    {this.state.cargandoParientes ? (
                                                        <div className="text-center py-4">
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Cargando...</span>
                                                            </div>
                                                            <p className="text-muted mt-2">Cargando acudientes...</p>
                                                        </div>
                                                    ) : parientes.length > 0 ? (
                                                        <div className="table-responsive">
                                                            <table className="table table-hover align-middle mb-0">
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Nombre</th>
                                                                        <th>Teléfono</th>
                                                                        <th>Email</th>
                                                                        <th>Parentesco</th>
                                                                        <th>Estado</th>
                                                                        <th className="text-center" style={{ width: '150px' }}>Acciones</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {parientes.map((pariente) => (
                                                                        <tr key={pariente.id}>
                                                                            <td>
                                                                                <b>{pariente.nombre}</b>
                                                                            </td>
                                                                            <td>{pariente.telefono || '-'}</td>
                                                                            <td>{pariente.email || '-'}</td>
                                                                            <td>
                                                                                <span className="badge bg-info text-white">
                                                                                    {pariente.parentesco || '-'}
                                                                                </span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`badge ${pariente.estado_nombre === 'Activo' || pariente.estado === 1 || String(pariente.estado_nombre).toLowerCase().includes('act') ? 'bg-success' : 'bg-secondary'}`}>
                                                                                    {pariente.estado_nombre || (pariente.estado === 1 ? 'Activo' : 'Inactivo')}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                <div className="btn-group" role="group">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-warning btn-sm"
                                                                                        onClick={() => this.activarFormParientes(pariente.id)}
                                                                                        title="Editar Acudiente"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faEdit} />
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-danger btn-sm"
                                                                                        onClick={() => this.eliminarPariente(pariente.id)}
                                                                                        title="Eliminar Acudiente"
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faTrashAlt} />
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    ) : (
                                                        <div className="text-center py-5">
                                                            <FontAwesomeIcon icon={faUsers} size="lg" className="text-muted mb-3" style={{ fontSize: '3rem' }} />
                                                            <p className="text-muted fs-5 mt-3">
                                                                No hay acudientes registrados para este paciente.
                                                            </p>
                                                            <button
                                                                className="btn btn-primary btn-md mt-2"
                                                                onClick={() => this.activarFormParientes()}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                                                Registrar primer acudiente
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* ==================== MODAL CREAR PACIENTE ==================== */}
                        <div
                            className="modal fade"
                            id="modal_paciente"
                            tabIndex="-1"
                            aria-labelledby="modalPacienteLabel"
                            aria-hidden="true"
                            style={{ display: 'none', zIndex: 1060 }}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header bg-success text-white">
                                        <h5 className="modal-title" id="modalPacienteLabel">
                                            <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                                            Registrar Nuevo Paciente
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            onClick={this.cerrarModalPaciente}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {cargandoModelos ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                                    <span className="visually-hidden">Cargando...</span>
                                                </div>
                                                <p className="text-muted">Cargando formulario de paciente...</p>
                                            </div>
                                        ) : errorModelos ? (
                                            <div className="alert alert-danger" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                Error al cargar el formulario: {errorModelos}
                                            </div>
                                        ) : modeloPaciente.tabla && modeloPaciente.tabla.length > 0 ? (
                                            <CrearFormulario
                                                menu={168}
                                                tabla={modeloPaciente.tabla}
                                                pesta={modeloPaciente.pesta}
                                                actualizarRelaciones={this.onPacienteRegistrado}
                                            />
                                        ) : (
                                            <div className="alert alert-warning" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                No se encontraron campos para mostrar en el formulario
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ==================== MODAL CREAR ARCHIVO ==================== */}
                        <div
                            className="modal fade"
                            id="modal_archivo"
                            tabIndex="-1"
                            aria-labelledby="modalArchivoLabel"
                            aria-hidden="true"
                            style={{ display: 'none', zIndex: 1060 }}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header bg-primary text-white">
                                        <h5 className="modal-title" id="modalArchivoLabel">
                                            <FontAwesomeIcon icon={faFolderPlus} className="me-2" />
                                            Crear Nuevo Archivo
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            onClick={this.cerrarModalArchivo}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {cargandoModelos ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                                    <span className="visually-hidden">Cargando...</span>
                                                </div>
                                                <p className="text-muted">Cargando formulario de archivo...</p>
                                            </div>
                                        ) : errorModelos ? (
                                            <div className="alert alert-danger" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                Error al cargar el formulario: {errorModelos}
                                            </div>
                                        ) : modeloArchivo.tabla && modeloArchivo.tabla.length > 0 ? (
                                            <CrearFormulario
                                                menu={200}
                                                tabla={modeloArchivo.tabla}
                                                pesta={modeloArchivo.pesta}
                                                llave="paciente"
                                                relacionid={pacienteId}
                                                actualizarRelaciones={this.onArchivoRegistrado}
                                            />
                                        ) : (
                                            <div className="alert alert-warning" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                No se encontraron campos para mostrar en el formulario
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ==================== MODAL CONDICIONES DE VIVIENDA ==================== */}
                        <div
                            className="modal fade"
                            id="modal_condiciones"
                            tabIndex="-1"
                            aria-labelledby="modalCondicionesLabel"
                            aria-hidden="true"
                            style={{ display: 'none', zIndex: 1060 }}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header bg-success text-white">
                                        <h5 className="modal-title" id="modalCondicionesLabel">
                                            <FontAwesomeIcon icon={faInfo} className="me-2" />
                                            {existeCondiciones ? 'Editar Condiciones de Vivienda' : 'Registrar Condiciones de Vivienda'}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            onClick={this.cerrarModalCondiciones}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {cargandoModelos ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                                    <span className="visually-hidden">Cargando...</span>
                                                </div>
                                                <p className="text-muted">Cargando formulario...</p>
                                            </div>
                                        ) : errorModelos ? (
                                            <div className="alert alert-danger" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                Error al cargar el formulario: {errorModelos}
                                            </div>
                                        ) : modeloCondiciones.tabla && modeloCondiciones.tabla.length > 0 ? (
                                            <CrearFormulario
                                                menu={195}
                                                tabla={modeloCondiciones.tabla}
                                                pesta={modeloCondiciones.pesta}
                                                llave="cedula"
                                                relacionid={pacienteId}
                                                idRegistro={condicionesId}
                                                actualizarRelaciones={this.onCondicionesRegistrado}
                                            />
                                        ) : (
                                            <div className="alert alert-warning" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                No se encontraron campos para mostrar en el formulario
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ==================== MODAL ACUDIENTES (PARIENTES) ==================== */}
                        <div
                            className="modal fade"
                            id="modal_parientes"
                            tabIndex="-1"
                            aria-labelledby="modalParientesLabel"
                            aria-hidden="true"
                            style={{ display: 'none', zIndex: 1060 }}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header bg-primary text-white">
                                        <h5 className="modal-title" id="modalParientesLabel">
                                            <FontAwesomeIcon icon={faUsers} className="me-2" />
                                            {parienteSeleccionadoId ? 'Editar Acudiente' : 'Registrar Acudiente'}
                                        </h5>
                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            onClick={this.cerrarModalParientes}
                                            aria-label="Close"
                                        ></button>
                                    </div>
                                    <div className="modal-body">
                                        {cargandoModelos ? (
                                            <div className="text-center py-5">
                                                <div className="spinner-border spinner-border-lg text-primary mb-3" role="status">
                                                    <span className="visually-hidden">Cargando...</span>
                                                </div>
                                                <p className="text-muted">Cargando formulario...</p>
                                            </div>
                                        ) : errorModelos ? (
                                            <div className="alert alert-danger" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                Error al cargar el formulario: {errorModelos}
                                            </div>
                                        ) : modeloParientes.tabla && modeloParientes.tabla.length > 0 ? (
                                            <CrearFormulario
                                                menu={192}
                                                tabla={modeloParientes.tabla}
                                                pesta={modeloParientes.pesta}
                                                llave="paciente"
                                                relacionid={pacienteId}
                                                idRegistro={parienteSeleccionadoId}
                                                actualizarRelaciones={this.onParientesRegistrado}
                                            />
                                        ) : (
                                            <div className="alert alert-warning" role="alert">
                                                <FontAwesomeIcon icon={faInfo} className="me-2" />
                                                No se encontraron campos para mostrar en el formulario
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;